import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatClock } from './duration';
import { vb } from './theme';

// "Estimated runtime 0:53 / 1:00 target" + bar (prototype). `locked` adds the
// explainer's fixed opening/closing to the displayed total.
const RuntimeMeter: React.FC<{
  label: string;
  narrationSeconds: number;
  lockedSeconds: number;
  targetSeconds: number;
  budgetSeconds: number;
  extra?: string;
}> = ({ label, narrationSeconds, lockedSeconds, targetSeconds, budgetSeconds, extra }) => {
  const total = narrationSeconds + lockedSeconds;
  const over = narrationSeconds > budgetSeconds + 0.05;
  const atLimit = !over && budgetSeconds - narrationSeconds < 1.5;
  const pct = Math.min(100, Math.round((total / Math.max(1, targetSeconds)) * 100));
  return (
    <Box data-testid="runtime-meter" sx={{ display: 'flex', flexDirection: 'column', gap: 0.6, minWidth: 220 }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
        <Typography
          sx={{
            fontFamily: vb.font,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: vb.textTertiary
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{ fontFamily: vb.font, fontSize: 16, fontWeight: 800, color: over ? vb.danger : vb.text }}
          data-testid="runtime-total"
        >
          {formatClock(total)}
        </Typography>
        <Typography sx={{ fontFamily: vb.font, fontSize: 12, color: vb.textTertiary }}>
          / {formatClock(targetSeconds)} target{extra ? ` · ${extra}` : ''}
        </Typography>
      </Box>
      <Box
        sx={{ height: 6, borderRadius: 3, background: vb.border, overflow: 'hidden' }}
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Estimated runtime"
      >
        <Box
          sx={{
            width: `${pct}%`,
            height: '100%',
            background: over ? vb.danger : atLimit ? vb.brand : vb.gradient,
            transition: 'width 0.2s ease'
          }}
        />
      </Box>
    </Box>
  );
};

export default RuntimeMeter;
